module.exports = __webpack_public_path__ + "static/media/HANDS_SET.80f92800.svg";